import React from 'react';
import Hero from './../components/Hero';
import Us from './../components/Us';
import SectionTitle from './../components/SectionTitle';
import PackagesGrid from './../components/PackagesGrid';
import BottomHero from './../components/BottomHero';

import { Grid } from "react-bootstrap";

class Home extends React.Component{
    render(){
        return(
            <Grid fluid>
                <Hero title={"Ideas creativas para eventos inolvidables"} />
                <Us />
                <SectionTitle title={'Paquetes'} />
                <PackagesGrid />
                <BottomHero />
            </Grid>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/containers/Home.js